import { render, staticRenderFns } from "./outairhandlewarning.vue?vue&type=template&id=f41f8da2&"
import script from "./outairhandlewarning.vue?vue&type=script&lang=ts&"
export * from "./outairhandlewarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports